import React, { useId } from 'react'
import {
  ExclamationMark,
  QuestionMark
} from 'icons/'
import {
  Container,
  CustomTooltip
} from './styles'
import { uuid4 } from '@sentry/utils'

const Tooltip = ({ variant, place, children }) => {
  const id = uuid4()

  const Icon = variant === 'info'
    ? ExclamationMark
    : QuestionMark

  return (
    <Container data-tip data-for={`tooltip-${id}`}>
      <Icon  />
      <CustomTooltip
        id={`tooltip-${id}`}
        clickable
        delayHide={200}
        place={place}
        type='light'
        effect='solid'
      >
        {children}
      </CustomTooltip>
    </Container>
  )
}

export default Tooltip